import { noAuthAxios } from "./api"

export const QUERY_KEY = "results"
export const BASE_URL = "app/results/"


export const listResults = ({ queryKey }: { queryKey: any }) => {
    const params = queryKey[1]
    const queryParams = Object.keys(params).map(p => `${p}=${params[p]}`).join("&")
    const url = BASE_URL + (queryParams ? `?${queryParams}` : "")
    return noAuthAxios.get(url)
}

export const detailResult = ({ queryKey }: { queryKey: any }) => {
    const resultId = queryKey[1]
    return noAuthAxios.get(`${BASE_URL}${resultId}/`)
}

export const collegeLeaderBoard = ({ queryKey }: { queryKey: any }) => {
    const params = queryKey[1]
    const queryParams = Object.keys(params).map(p => `${p}=${params[p]}`).join("&")
    const url = `${BASE_URL}college_leaderboard/` + (queryParams ? `?${queryParams}` : "")
    return noAuthAxios.get(url)
}

export const individualLeaderBoard = ({ queryKey }: { queryKey: any }) => {
    const params = queryKey[1]
    const queryParams = Object.keys(params).map(p => `${p}=${params[p]}`).join("&")
    const url = `${BASE_URL}individual_leaderboard/` + (queryParams ? `?${queryParams}` : "")
    return noAuthAxios.get(url)
}
